<template>
    <v-card flat>
        <v-card-title>
            Búsquedas realizadas.
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
            </v-text-field>
        </v-card-title>

        <v-data-table :headers="headers" :items="sugerencias" :search="search" loading-text="Loading... Please wait"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" item-key="id_busqueda" show-expand :single-expand=true
            @item-expanded="expandDetail">

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <v-row class="mt-0">
                        <v-col v-for="check in checkitems" v-bind:key="check">
                            <v-simple-checkbox v-if="item[check] == null" indeterminate v-model="item[check]" disabled>
                            </v-simple-checkbox>
                            <v-simple-checkbox v-else v-model="item[check]" :label="check"
                                :color="item[check] ? 'green' : 'red'" off-icon="mdi-close-box-outline">
                            </v-simple-checkbox>
                            {{ check }}
                        </v-col>
                    </v-row>
                    <v-row class="mb-0">
                        <v-col>
                            <v-btn class="mr-2" color="primary" @click="editSugerencia(item.id_busqueda)">
                                Ver resultados
                            </v-btn>
                        </v-col>
                    </v-row>
                </td>
            </template>


            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editSugerencia(item.id_busqueda)">mdi-eye</v-icon>
                <v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
            </template>

        </v-data-table>

        <v-dialog v-model="dialogDelete" persistent max-width="400">
            <v-card>
                <v-card-title class="text-h5">
                    {{ itemToDelete.usuario }} - {{ itemToDelete.fecha }}
                </v-card-title>
                <v-card-text>¿Estás seguro de querer borrar la búsqueda?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="dialogDelete = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" text @click="deleteBusqueda(itemToDelete.id_busqueda)">
                        Borrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-card>
</template>

<script>
import { mapMutations } from "vuex";
import SugerenciasDataService from "@/services/SugerenciasDataService";
export default {
    name: "SugerenciasList",
    data: () => ({
        sugerencias: [],
        search: '',
        sortBy: 'fecha',
        sortDesc: true,
        headers: [
            { text: 'PT/PX', value: 'ptpx' },
            { text: 'POST', value: 'postcurado' },
            { text: 'Dureza', value: 'dureza' },
            { text: 'TEMP', value: 'temp_servicio' },
            { text: 'PROC.', value: 'proceso' },
            { text: 'COLOR', value: 'color' },
            { text: 'usuario', value: 'usuario' },
            { text: 'fecha', value: 'fecha' },
            { text: "Actions", value: "actions", sortable: false },
        ],
        checkitems: ['esponja', 'aceite', 'cables', 'desmoldeo', 'fda', 'fuego', 'grasa', 'green_strength'],
        procesos: [
            { name: "Autoclave", abbr: "AC", value: "autoclave" },
            { name: "Calandra", abbr: "C", value: "calandra" },
            { name: "Extrusion", abbr: "E", value: "extrusion" },
            { name: "Moldeo", abbr: "M", value: "moldeo" },
        ],
        listaKey: 0,
        dialogDelete: false,
        itemToDelete: {},
    }),
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        expandDetail({ item }) {
            this.listaKey += 1;
        },
        editSugerencia(id) {
            this.$router.push({ name: "SugerenciaId", params: { id: id } });
        },
        retrieveSugerencias() {
            SugerenciasDataService.getAll()
                .then((response) => {
                    // console.log("SUGERENCIAS RECIBIDAS"); console.log(response);
                    this.sugerencias = response.data.map(this.getDisplaySugerencia);
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getDisplaySugerencia(sugerencia) {
            let strcolor = "";
            if (sugerencia.id_color) {
                strcolor = sugerencia.id_color.nombre;
                if (sugerencia.id_color.ral) {
                    strcolor += " (" + sugerencia.id_color.ral + ") ";
                }
                if (sugerencia.id_color.referencia) {
                    strcolor += sugerencia.id_color.referencia;
                }
            }
            let sugerencia_proceso = "";
            for (const p of this.procesos) {
                if (sugerencia.proceso == p.value) {
                    sugerencia_proceso = p.abbr;
                }
            }
            function pad2(n) {
                return (n < 10 ? '0' : '') + n;
            }
            let date = new Date(sugerencia.created_at);
            let month = pad2(date.getMonth() + 1);//months (0-11)
            let day = pad2(date.getDate());//day (1-31)
            let year = date.getFullYear();
            let hh = pad2(date.getHours());
            let mn = pad2(date.getMinutes());
            let formattedDate = year + "/" + month + "/" + day + " " + hh + ":" + mn;

            return {
                fecha: formattedDate,
                id_busqueda: sugerencia.id_busqueda,
                usuario: sugerencia.id_usuario ? sugerencia.id_usuario.username : "ND",
                ptpx: sugerencia.peroxido && sugerencia.platino ? "Ambas" : (sugerencia.platino ? "PT" : "PX"),
                postcurado: sugerencia.con_postcurado && sugerencia.sin_postcurado ? "Ambas" : (sugerencia.con_postcurado ? "CON" : "SIN"),
                dureza: sugerencia.dureza,
                temp_servicio: sugerencia.temp_servicio,
                esponja: sugerencia.esponja,

                proceso: sugerencia_proceso,
                color: strcolor,
                aceite: sugerencia.aceite,
                cables: sugerencia.cables,
                desmoldeo: sugerencia.desmoldeo,
                fda: sugerencia.fda,
                fuego: sugerencia.fuego,
                grasa: sugerencia.grasa,
                green_strength: sugerencia.green_strength,
            };
        },
        showDeleteDialog(item) {
            this.itemToDelete = item
            this.dialogDelete = !this.dialogDelete
        },
        deleteBusqueda(id) {
            SugerenciasDataService.delete(id)
                .then(() => {
                    this.dialogDelete = false
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    setTimeout(() => this.$router.go(), 500);
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
    },
    mounted() {
        this.retrieveSugerencias();
    }
};
</script>
